<fleetoperate-fleetoperate-toolbar
  [data]="data"
  [profilePath]="profilePath"
  [actions]="actions"
  (logout)="onLogout()"
></fleetoperate-fleetoperate-toolbar>
